var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isNativePullPost)?_c('div',{staticClass:"ttam-library-tips"},[_c('vi-alert',{attrs:{"data-testid":"tips-index-nncedR","title":_vm.$t('module_creative_native_post_prompt'),"closable":false,"type":"info","show-icon":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }